module.exports = __webpack_public_path__ + "static/img/A158.36200e0d.jpg";